/** The envoy's state as a dot: green and breathing while it is on, grey while it is off. */
export default function EnvoyDot({ on }: { on: boolean }) {
    return (
        <span
            className={`size-2 shrink-0 rounded-full ${on ? "bg-green envoy-pulse" : "bg-line-control"}`}
            aria-hidden="true"
        />
    );
}
